import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgLoading = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("style", null, `
          @keyframes kf1{0%,33.33%,6.67%{transform:translate(12px,12px) rotate(-90deg) translate(-12px,-12px)}50%{transform:translate(12px,12px) rotate(15deg) translate(-12px,-12px)}60%{transform:translate(12px,12px) rotate(100deg) translate(-12px,-12px)}to{transform:translate(12px,12px) rotate(270deg) translate(-12px,-12px)}}

          @keyframes kf2{0%,to{stroke-dashoffset:56.56}6.67%{stroke-dashoffset:54.282}50%,60%{stroke-dashoffset:45}}

          @keyframes kf3{0%,33.33%,6.67%{stroke-dasharray:56.56}50%,to{stroke-dasharray:56.56,56.56}}`),
        React.createElement("g", { style: {
                transform: 'translate(12px,12px) rotate(-90deg) translate(-12px,-12px)',
                animationFillMode: 'backwards',
                animationName: 'kf1',
                animationTimingFunction: 'cubic-bezier(0,0,1,1)',
                animationDuration: '1s',
                animationIterationCount: 'infinite'
            }, fillRule: "evenodd", fill: "none" },
            React.createElement("circle", { cx: 12, cy: 12, r: 9, style: {
                    animationFillMode: 'backwards,backwards',
                    animationName: 'kf2,kf3',
                    animationTimingFunction: 'cubic-bezier(.42,0,1,1),cubic-bezier(0,0,1,1)',
                    animationDuration: '1s',
                    animationIterationCount: 'infinite'
                }, stroke: color, strokeWidth: 2, strokeLinecap: "round", strokeDasharray: 56.56, strokeDashoffset: 56.56, "data-animator-group": "true", "data-animator-type": 1, transform: "rotate(-90 12 12)" }))));
};
export default factorySvgIcon(SvgLoading);
//# sourceMappingURL=SvgLoading.js.map